<script setup lang="ts">
const root = useRoot();
</script>

<template>
  <div class="py-10">
    <nav
      id="footer-bottom-menu"
      class="container flex flex-col justify-between gap-10 lg:flex-row"
    >
      <ul
        class="flex flex-col justify-between gap-4 text-center text-base"
        :class="['lg:flex-row lg:text-left']"
        :aria-label="$t('Aria.Global.Footer.PolicyList')"
      >
        <li v-if="root.settings?.content.cvr">
          <p class="text-left">{{ $t('General.Settings.Cvr') }} {{ root.settings?.content.cvr }}</p>
        </li>

        <li v-if="root.settings?.content.cookieLink">
          <UmbracoLink
            :link="root.settings?.content.cookieLink"
            :has-underline="true"
          />
        </li>

        <li v-if="root.settings?.content.privacyPolicy">
          <UmbracoLink
            :link="root.settings?.content.privacyPolicy"
            :has-underline="true"
          />
        </li>
      </ul>
    </nav>
  </div>
</template>
